import { Pagination } from '@/components/ui'
import { useSummarizationPage } from '@/hooks/useToolManagement/useSummarizationPage'

import { SummarizationSearchBar } from './SummarizationSearchBar'
import { SummaryTable } from './SummaryTable'

export function SummarizationTable() {
  const {
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    currentPage,
    setCurrentPage,
    summaries,
    totalPages,
    error,
    sortColumn,
    sortDirection,
    onSort,
  } = useSummarizationPage()

  if (error) {
    return <div className='text-center py-8 text-red-600'>{error}</div>
  }

  return (
    <>
      {(summaries.length > 0 ||
        searchTerm.trim().length > 0 ||
        statusFilter) && (
        <SummarizationSearchBar
          searchTerm={searchTerm}
          statusFilter={statusFilter}
          onSearchChange={setSearchTerm}
          onStatusFilterChange={setStatusFilter}
        />
      )}

      <div className='space-y-6'>
        <SummaryTable
          summaries={summaries}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={onSort}
        />
      </div>

      {totalPages > 1 && (
        <div className='flex justify-end mt-6'>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </>
  )
}
